import { render } from "./CodeBlock.vue?vue&type=template&id=46c81610"
import script from "./CodeBlock.vue?vue&type=script&lang=js"
export * from "./CodeBlock.vue?vue&type=script&lang=js"

import "./CodeBlock.vue?vue&type=style&index=0&id=46c81610&lang=css"

import exportComponent from "/codebuild/output/src2646400178/src/twilio-clone/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__